import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@carrier-io/air-react/Box';
import { ActiveButtonType, Navbar, NavbarFooter, NavigationButton } from '@carrier-io/air-react/patterns/Navbar';

import HomeIcon from './icons/home-icon';
import SettingsIcon from './icons/settings-icon';
import QuestionIcon from './icons/question-icon';
import { PrivateRoute } from 'constants/routes';

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMemberDashboard = location.pathname === PrivateRoute.MemberDashboard;
  const isVendorDashboard = location.pathname.includes(PrivateRoute.VendorDashboard);
  const isMemberPage = location.pathname.includes('/member');

  const goToMemberDashboard = () => navigate(PrivateRoute.MemberDashboard, { replace: true });

  return (
    <Box
      sx={{
        background: 'rgba(222,219,240,0.24)',
        border: '1px solid #DCDEE0',
        height: 'calc(100vh - 46px)',
        overflow: 'hidden',
        width: '56px',
        position: 'fixed',
        marginTop: '48px',
      }}
    >
      <Navbar disableHoverListener>
        <NavigationButton
          activeButtonType={ActiveButtonType.Basic}
          active={isMemberDashboard || isVendorDashboard}
          data={{
            id: 'Dashboard',
            label: 'Dashboard',
          }}
          disableTooltip
          disabled={isMemberDashboard || !isMemberPage}
          onClick={goToMemberDashboard}
        >
          <HomeIcon />
        </NavigationButton>
        <NavbarFooter showCarrierLogo>
          <NavigationButton
            activeButtonType={ActiveButtonType.Basic}
            data={{
              id: 'settings',
              label: 'Settings',
            }}
            disableTooltip
            onClick={() => alert('Settings')}
          >
            <SettingsIcon />
          </NavigationButton>
          <NavigationButton
            activeButtonType={ActiveButtonType.Basic}
            data={{
              id: 'chat',
              label: 'Chat',
            }}
            disableTooltip
            onClick={() => alert('Questions')}
          >
            <QuestionIcon />
          </NavigationButton>
        </NavbarFooter>
      </Navbar>
    </Box>
  );
};

export default SideBar;
